module.exports = {"id":"216335","name":"Yuriy Gazinskiy","rating":"75","photo":"./data/images/photos/4/216335.png","club":{"name":"FK Krasnodar","logo":"./data/images/clubs/FKKrasnodar.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YuriyGazinskiy0.json
// module id = 4445
// module chunks = 0